import { render, staticRenderFns } from "./ProgramProductItemForm.vue?vue&type=template&id=c63720e6"
import script from "./ProgramProductItemForm.vue?vue&type=script&lang=js"
export * from "./ProgramProductItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports